import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { Form, Formik } from 'formik';
import clsx from 'clsx';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Button from '@mui/material/Button';
import { useCommonStyles } from '../../../common/common';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { onJwtSignUp } from '../../../store/actions/Auth';
import { SignUpSchema } from '../../../schemas/SignUpSchema.schema';
import InputField from '../../../common/InputField';
import { useRegisterStyles } from '..';
import AppLogoComp from '../../../common/AppLogo';

interface SignUpOptionState {
    name: string;
	email: string;
	password: string;
	cpassword: string;
    showPassword: boolean;
}

const Signup = () => {
    const [values, setValues] = useState<SignUpOptionState>({
		name: '',
        email: '',
		password: '',
		cpassword: '',
        showPassword: false
	})

    const classes = useRegisterStyles();
    const {
        pointer,
        signInButton,
        paper, formRoot
    } = classes
    const { d_f_row_center, mainContainer, w_100 } = useCommonStyles()
    const dispatch = useDispatch()

    const submitHandler = (data: any, setSubmitting: any) => {
		setSubmitting(true);
        dispatch( onJwtSignUp({name: data.name, email: data.email, password: data.password}) )
		setSubmitting(false);
	}
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};

	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};

    return (
        <Box className={clsx(mainContainer,d_f_row_center)}>
            <Grid container>
                <Grid item sm={3} lg={4}></Grid>
                <Grid item xs={12} sm={6} lg={4}
                    style={{
                        backgroundColor: '#d7d5d526',
                        borderRadius: '4px',
                        marginBottom: '32px'
                    }}
                >
                    <AppLogoComp />
                    <Paper className={paper}>
                        <Formik
                            validateOnChange={true}
                            initialValues={{
                                ...values
                            }}
                            validationSchema={SignUpSchema}
                            onSubmit={(data, { setSubmitting }) => submitHandler(data, setSubmitting)}>
                            {({ isSubmitting }) => (
                                <Form className={formRoot} noValidate autoComplete='off'>
                                    <Box
                                        mb={{ xs: 2, xl: 3 }}
                                        component='div'
                                        fontSize={16}>
                                        Enter username
                                    </Box>
                                    <Box>
                                        <InputField
                                            placeholder='Enter username'
                                            name='name'
                                            variant='outlined'
                                            className={clsx(w_100)}
                                        />
                                    </Box>
                                    <Box
                                        mt={{ xs: 3, xl: 3 }}
                                        mb={{ xs: 2, xl: 3 }}
                                        component='div'
                                        fontSize={16}>
                                        Enter email address
                                    </Box>
                                    <Box>
                                        <InputField
                                            placeholder='Enter email address'
                                            name='email'
                                            variant='outlined'
                                            className={clsx(w_100)}
                                        />
                                    </Box>
                                    <Box
                                        mt={{ xs: 3, xl: 3 }}
                                        mb={{ xs: 2, xl: 3 }}
                                        component='div'
                                        fontSize={16}>
                                        Enter password
                                    </Box>
                                    <Box>
                                        <InputField
                                            placeholder='Enter password'
                                            name='password'
                                            variant='outlined'
                                            className={clsx(w_100)}
                                        />
                                    </Box>
                                    <Box
                                        mt={{ xs: 3, xl: 3 }}
                                        mb={{ xs: 2, xl: 3 }}
                                        component='div'
                                        fontSize={16}>
                                        Confirm password
                                    </Box>
                                    <Box>
                                        <InputField
                                            type={values.showPassword ? 'text' : 'password'}
                                            placeholder='Confirm password'
                                            name='cpassword'
                                            variant='outlined'
                                            className={clsx(w_100)}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                    >
                                                        {values.showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                                    </IconButton>
                                                </InputAdornment>,
                                            }}
                                        />
                                    </Box>
                                    <Box
                                        mt={{ xs: 3, xl: 3 }}
                                        mb={{ xs: 3, xl: 3 }}
                                        display='flex'
                                        flexDirection='column'>
                                        <Button
                                            type='submit'
                                            color="primary"
                                            variant="contained"
                                            disabled={isSubmitting}
                                            className={clsx(signInButton)}>
                                            Sign Up
                                        </Button>
                                    </Box>
                                    <Box
                                        mb={{ xs: 3, xl: 3 }}
                                        display='flex'
                                        flexDirection={'column'}
                                        alignItems={'center'}
                                        justifyContent={ 'center' }
                                        fontSize={15}>
                                        <Box
                                            color='primary.secondary'
                                            component='span'
                                            className={pointer}
                                            fontSize={15}
                                        >
                                            <b>Already have an account</b>, <Link to="/signin">Login Here</Link>
                                        </Box>
                                    </Box>
                                </Form>
                            )}
                        </Formik>
                    </Paper>
                </Grid>
                <Grid item sm={3} md={4} lg={4}></Grid>
            </Grid>
        </Box>
    );
};

export default Signup;
